<div class="sup-page">

  <!-- Toast -->
  <div class="sup-toast" *ngIf="toastMsg">
    <span class="material-icons">check_circle</span>{{ toastMsg }}
  </div>

  <!-- Broadcast Modal -->
  <div class="sup-overlay" *ngIf="showBroadcast" (click)="showBroadcast = false">
    <div class="sup-modal" (click)="$event.stopPropagation()" style="max-width:420px">
      <div class="sup-modal-hd">
        <span style="display:flex;align-items:center;gap:8px">
          <span class="material-icons" style="font-size:16px">campaign</span>Broadcast Alert to Agents
        </span>
        <button class="sup-btn btn-ghost" style="padding:4px 8px" (click)="showBroadcast = false">
          <span class="material-icons" style="font-size:15px">close</span>
        </button>
      </div>
      <div class="sup-modal-bd">
        <label class="sup-input-label">Message</label>
        <textarea class="sup-textarea" placeholder="Type your broadcast message for all agents..."
          [(ngModel)]="broadcastMsg" autofocus></textarea>
        <div style="font-size:12px;color:var(--csr-text2);display:flex;align-items:center;gap:6px;margin-top:8px">
          <span class="material-icons" style="font-size:13px">headset_mic</span>
          Will be sent to all {{ activeAgentsCount }} active agents immediately.
        </div>
      </div>
      <div class="sup-modal-ft">
        <button class="sup-btn btn-ghost" (click)="showBroadcast = false">Cancel</button>
        <button class="sup-btn btn-danger" (click)="sendBroadcast()" [disabled]="!broadcastMsg.trim()">
          <span class="material-icons">send</span>Send Broadcast
        </button>
      </div>
    </div>
  </div>

  <!-- Stat Detail Modal -->
  <div class="sup-overlay" *ngIf="activeStatModal" (click)="closeStatModal()">
    <div class="sup-modal" (click)="$event.stopPropagation()" style="max-width:560px">
      <div class="sup-modal-hd">
        <span style="display:flex;align-items:center;gap:8px">
          <span class="material-icons" style="font-size:16px">
            {{ activeStatModal === 'Active Agents' ? 'headset_mic'
             : activeStatModal === 'Live Calls'    ? 'phone_in_talk'
             : activeStatModal === 'In Queue'      ? 'layers'
             : activeStatModal === 'Avg Handle'    ? 'timer'
             : activeStatModal === 'Timeline Breaches' ? 'warning_amber'
             : 'check_circle' }}
          </span>
          {{ activeStatModal === 'In Queue' ? 'Queue Detail' : activeStatModal }}
        </span>
        <button class="sup-btn btn-ghost" style="padding:4px 8px" (click)="closeStatModal()">
          <span class="material-icons" style="font-size:15px">close</span>
        </button>
      </div>
      <div class="sup-modal-bd">

        <!-- Active Agents -->
        <ng-container *ngIf="activeStatModal === 'Active Agents'">
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:16px">
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:var(--csr-accent)">{{ agentOnCallCount }}</div>
              <div class="sup-mini-lbl">On Call</div>
            </div>
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:#66bb6a">{{ agentAvailableCount }}</div>
              <div class="sup-mini-lbl">Available</div>
            </div>
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:var(--csr-text2)">{{ agentOfflineCount }}</div>
              <div class="sup-mini-lbl">Offline</div>
            </div>
          </div>
          <div style="display:flex;flex-direction:column;gap:6px">
            <div style="display:flex;align-items:center;gap:12px;padding:8px 12px;background:var(--csr-surface2);border:1px solid var(--csr-border);border-radius:8px"
                 *ngFor="let g of agentRoleGroups">
              <span class="material-icons" style="font-size:14px;color:var(--csr-text2)">group</span>
              <span style="flex:1;font-size:13px">{{ g.role }}</span>
              <span style="font-size:12px;color:var(--csr-text2)">{{ g.count }} agents · {{ g.onCall }} on call</span>
              <span class="sup-badge" [ngClass]="g.statusLabel==='On Call'?'sb-blue':g.statusLabel==='Mixed'?'sb-amber':'sb-green'">{{ g.statusLabel }}</span>
            </div>
            <div *ngIf="agentRoleGroups.length === 0" style="font-size:13px;color:var(--csr-text2);padding:8px 0">
              No agents currently online
            </div>
          </div>
        </ng-container>

        <!-- Live Calls -->
        <ng-container *ngIf="activeStatModal === 'Live Calls'">
          <div style="display:flex;flex-direction:column;gap:7px">

            <!-- Coaching banner -->
            <div *ngIf="coachingExt"
                 [style]="coachingPending
                   ? 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(156,163,175,.10);border:1px solid rgba(156,163,175,.4);border-radius:9px;font-size:12px'
                   : 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(34,197,94,.12);border:1px solid rgba(34,197,94,.5);border-radius:9px;font-size:12px'">
              <span class="material-icons"
                    [style]="coachingPending ? 'font-size:14px;color:#9ca3af' : 'font-size:14px;color:#16a34a'">
                {{coachingPending ? 'schedule' : 'hearing'}}
              </span>
              <span style="flex:1;color:var(--csr-text)">
                <ng-container *ngIf="coachingPending">
                  Coaching Ext <strong>{{coachingExt}}</strong> — connecting...
                </ng-container>
                <ng-container *ngIf="!coachingPending">
                  <span style="display:inline-flex;align-items:center;gap:5px">
                    <span style="width:7px;height:7px;border-radius:50%;background:#16a34a;display:inline-block;animation:pulse-dot 1.4s infinite"></span>
                    <strong>LIVE</strong>
                  </span>
                  &nbsp;Coaching Ext <strong>{{coachingExt}}</strong> — you hear the call; your voice goes to the CSR only (the citizen cannot hear you)
                </ng-container>
              </span>
              <button (click)="stopCoach()"
                      style="background:#c0392b;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer">
                Stop
              </button>
            </div>

            <!-- Monitoring banner -->
            <div *ngIf="monitoringExt"
                 [style]="monitoringPending
                   ? 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(156,163,175,.10);border:1px solid rgba(156,163,175,.4);border-radius:9px;font-size:12px'
                   : 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(6,182,212,.12);border:1px solid rgba(6,182,212,.5);border-radius:9px;font-size:12px'">
              <span class="material-icons"
                    [style]="monitoringPending ? 'font-size:14px;color:#9ca3af' : 'font-size:14px;color:#06b6d4'">
                {{monitoringPending ? 'schedule' : 'hearing'}}
              </span>
              <span style="flex:1;color:var(--csr-text)">
                <ng-container *ngIf="monitoringPending">
                  Monitoring Ext <strong>{{monitoringExt}}</strong> — connecting...
                </ng-container>
                <ng-container *ngIf="!monitoringPending">
                  <span style="display:inline-flex;align-items:center;gap:5px">
                    <span style="width:7px;height:7px;border-radius:50%;background:#06b6d4;display:inline-block;animation:pulse-dot 1.4s infinite"></span>
                    <strong>LIVE</strong>
                  </span>
                  &nbsp;Monitoring Ext <strong>{{monitoringExt}}</strong> — you can hear the call (your mic is muted)
                </ng-container>
              </span>
              <button (click)="stopMonitor()"
                      style="background:#c0392b;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer">
                Stop
              </button>
            </div>

            <div *ngFor="let c of liveCalls"
                 style="display:flex;align-items:center;gap:8px;padding:9px 12px;background:var(--csr-surface2);border:1px solid var(--csr-border);border-radius:9px"
                 [style.border-color]="coachingExt === c.agentExt ? 'rgba(139,92,246,.6)' : monitoringExt === c.agentExt ? 'rgba(6,182,212,.6)' : ''">
              <span class="sup-pri" [ngClass]="'p-'+c.pri"></span>
              <span style="font-size:11px;color:var(--csr-text2);font-family:monospace;flex-shrink:0">{{c.id}}</span>
              <div style="flex:1">
                <div style="font-size:13px;font-weight:600">{{c.citizen}} <span style="font-size:11px;color:var(--csr-text2)">· {{c.dept}}</span></div>
                <div style="font-size:11px;color:var(--csr-text2)">{{c.agent}}</div>
              </div>
              <div style="display:flex;align-items:center;gap:5px;font-size:13px;font-weight:700;color:var(--csr-accent)">
                <span class="material-icons" style="font-size:12px">phone</span>{{c.dur}}
              </div>

              <!-- Coach button — hidden while monitoring this agent -->
              <ng-container *ngIf="monitoringExt !== c.agentExt">
                <button *ngIf="coachingExt !== c.agentExt; else stopCoachBtn"
                        (click)="startCoach(c.agentExt)"
                        [disabled]="!!coachingExt"
                        style="background:#6d28d9;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer;white-space:nowrap;opacity:1"
                        [style.opacity]="coachingExt && coachingExt !== c.agentExt ? '0.4' : '1'">
                  <span class="material-icons" style="font-size:12px;vertical-align:-2px">record_voice_over</span> Coach
                </button>
                <ng-template #stopCoachBtn>
                  <button (click)="stopCoach()"
                          style="background:#c0392b;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer">
                    Stop
                  </button>
                </ng-template>
              </ng-container>

              <!-- Monitor button — hidden while coaching this agent -->
              <ng-container *ngIf="coachingExt !== c.agentExt">
                <button *ngIf="monitoringExt !== c.agentExt; else stopMonitorBtn"
                        (click)="startMonitor(c.agentExt)"
                        [disabled]="!!monitoringExt"
                        style="background:#0e7490;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer;white-space:nowrap"
                        [style.opacity]="monitoringExt && monitoringExt !== c.agentExt ? '0.4' : '1'">
                  <span class="material-icons" style="font-size:12px;vertical-align:-2px">hearing</span> Monitor
                </button>
                <ng-template #stopMonitorBtn>
                  <button (click)="stopMonitor()"
                          style="background:#c0392b;border:none;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer">
                    Stop
                  </button>
                </ng-template>
              </ng-container>

            </div>
          </div>
        </ng-container>

        <!-- In Queue -->
        <ng-container *ngIf="activeStatModal === 'In Queue'">
          <div style="display:flex;flex-direction:column;gap:7px">
            <div *ngFor="let q of queueItems"
                 style="display:flex;align-items:center;gap:12px;padding:8px 12px;background:var(--csr-surface2);border:1px solid var(--csr-border);border-radius:9px">
              <span style="font-size:12px;font-weight:700;color:var(--csr-text2);width:22px;text-align:center;flex-shrink:0">#{{q.pos}}</span>
              <span class="sup-pri" [ngClass]="'p-'+q.pri"></span>
              <div style="flex:1">
                <div style="font-size:13px;font-weight:600">{{q.citizen}} <span style="font-size:11px;color:var(--csr-text2)">· {{q.dept}}</span></div>
                <span class="sup-ch" [ngClass]="'ch-'+q.ch" style="font-size:10px;margin-top:2px">{{q.ch}}</span>
              </div>
              <div style="font-size:13px;font-weight:700"
                   [style.color]="q.pri==='critical'?'#ef5350':q.pri==='high'?'#ffa726':'var(--csr-text2)'">
                <span class="material-icons" style="font-size:11px;vertical-align:middle">schedule</span>{{q.wait}}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Avg Handle -->
        <ng-container *ngIf="activeStatModal === 'Avg Handle'">
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:16px">
            <div class="sup-mini-card" *ngFor="let s of [['Today Avg','4:12','#26c6da'],['Target Timeline','5:00','#66bb6a'],['Yesterday','4:48','var(--csr-text2)']]">
              <div class="sup-mini-val" [style.color]="s[2]">{{s[1]}}</div>
              <div class="sup-mini-lbl">{{s[0]}}</div>
            </div>
          </div>
          <div style="overflow-x:auto">
            <table class="sup-tbl">
              <thead><tr><th>Agent</th><th>Unit</th><th>Calls</th><th>Avg Handle</th></tr></thead>
              <tbody>
                <tr *ngFor="let r of [['Sara Ahmed','PLRA','14','3:42'],['Usman Ali','Revenue Office','11','4:15'],['Bilal Mahmood','Operations','9','3:58'],['Zara Khan','Registry Branch','12','4:30'],['Amna Tariq','Arazi Record Center','8','5:01'],['Fahad Raza','Project Safeguards','10','4:50']]">
                  <td style="font-weight:600">{{r[0]}}</td>
                  <td class="td2">{{r[1]}}</td>
                  <td><span class="sup-badge sb-blue">{{r[2]}}</span></td>
                  <td style="font-weight:700" [style.color]="(r[3] | slice:0:1) < '4' ? '#66bb6a' : (r[3] | slice:0:1) > '5' ? '#ef5350' : '#ffa726'">{{r[3]}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- Timeline Breaches -->
        <ng-container *ngIf="activeStatModal === 'Timeline Breaches'">
          <div style="display:flex;flex-direction:column;gap:12px">
            <div *ngFor="let b of breaches"
                 style="background:rgba(239,83,80,0.06);border:1px solid rgba(239,83,80,0.25);border-radius:10px;padding:14px">
              <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px">
                <div>
                  <div style="font-size:13px;font-weight:700">{{b.title}}</div>
                  <div style="font-size:11px;color:var(--csr-text2);margin-top:2px">{{b.id}} · {{b.dept}} · Agent: {{b.agent}}</div>
                </div>
                <span class="sup-badge sb-red"><span class="material-icons" style="font-size:11px">warning</span>Breached</span>
              </div>
              <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px">
                <div style="background:var(--csr-surface2);border-radius:7px;padding:8px 10px">
                  <div style="font-size:10px;color:var(--csr-text2);margin-bottom:2px">Timeline Target</div>
                  <div style="font-size:13px;font-weight:700;color:var(--csr-text2)">{{b.sla}}</div>
                </div>
                <div style="background:var(--csr-surface2);border-radius:7px;padding:8px 10px">
                  <div style="font-size:10px;color:var(--csr-text2);margin-bottom:2px">Time Elapsed</div>
                  <div style="font-size:13px;font-weight:700;color:#ffa726">{{b.elapsed}}</div>
                </div>
                <div style="background:var(--csr-surface2);border-radius:7px;padding:8px 10px">
                  <div style="font-size:10px;color:var(--csr-text2);margin-bottom:2px">Over by</div>
                  <div style="font-size:13px;font-weight:700;color:#ef5350">{{b.breachBy}}</div>
                </div>
              </div>
            </div>
            <div style="font-size:12px;color:var(--csr-text2);text-align:center">
              <span class="material-icons" style="font-size:13px;vertical-align:middle;margin-right:4px">monitor_heart</span>
              Both cases escalated to service unit heads automatically
            </div>
          </div>
        </ng-container>

        <!-- Resolved Today -->
        <ng-container *ngIf="activeStatModal === 'Resolved Today'">
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:16px">
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:#66bb6a">{{ stats[5].val }}</div>
              <div class="sup-mini-lbl">Total Resolved</div>
            </div>
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:#26c6da">{{ stats[3].val }}</div>
              <div class="sup-mini-lbl">Avg Handle</div>
            </div>
            <div class="sup-mini-card">
              <div class="sup-mini-val" style="color:#ab47bc">{{ stats[4].val }}</div>
              <div class="sup-mini-lbl">Timeline Breaches</div>
            </div>
          </div>
          <div style="display:flex;flex-direction:column;gap:9px">
            <div *ngFor="let d of resolvedByDept">
              <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:5px">
                <span>{{d.dept}}</span>
                <span><strong [style.color]="resolvedColor(d.col)">{{d.count}}</strong> <span style="color:var(--csr-text2)">({{d.pct}}%)</span></span>
              </div>
              <div class="sup-prog-bar"><div class="sup-prog-fill" [ngClass]="progColor(d.col)" [style.width]="d.pct+'%'"></div></div>
            </div>
          </div>
        </ng-container>

      </div>
      <div class="sup-modal-ft">
        <button class="sup-btn btn-ghost" (click)="closeStatModal()">Close</button>
      </div>
    </div>
  </div>

  <!-- Page Header -->
  <div class="sup-page-header">
    <div>
      <div class="sup-page-title">Supervisor Control Room</div>
      <div class="sup-page-sub">
        Live monitoring ·
        <span style="color:#66bb6a">{{ clock }}</span>
      </div>
    </div>
    <!-- sup-page-actions hidden: Broadcast Alert and Systems Normal not linked to contact centre -->

  </div>

  <!-- Stats Grid — Timeline Breaches and Resolved Today hidden (not linked to contact centre) -->
  <div class="sup-stats-grid sup-control-room-stats">
    <ng-container *ngFor="let s of stats">
      <div *ngIf="s.label !== 'Timeline Breaches' && s.label !== 'Resolved Today'"
           class="sup-stat-card" [ngClass]="'sc-'+s.col" (click)="openStatModal(s.label)">
        <span class="sup-stat-icon material-icons">{{s.icon}}</span>
        <div class="sup-stat-label">{{s.label}}</div>
        <div class="sup-stat-value">{{s.val}}</div>
      </div>
    </ng-container>
  </div>

  <!-- Agent Status (Escalations hidden — not linked to contact centre) -->
  <div>
    <!-- Agent Grid Card -->
    <div class="sup-card">
      <div class="sup-card-header">
        <span class="sup-card-title">
          <span class="material-icons">group</span>Agent Status
        </span>
        <span style="font-size:12px;color:var(--csr-text2)">{{ agents.length }} Total</span>
      </div>
      <div class="sup-card-body">
        <div class="sup-agent-grid">
          <div *ngFor="let a of agents" class="sup-agent-card">
            <div class="sup-agent-stripe" [ngClass]="agentStripe(a.status)"></div>
            <div style="display:flex;align-items:center;gap:8px;margin-top:8px;margin-bottom:8px">
              <div class="sup-avatar"
                   [style.background]="'linear-gradient(135deg,' + a.gradFrom + ',' + a.gradTo + ')'">
                {{a.initials}}
              </div>
              <div style="overflow:hidden">
                <div style="font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{a.name}}</div>
                <div style="font-size:10px;color:var(--csr-text2)">{{a.ext}}</div>
              </div>
            </div>
            <span class="sup-badge" [ngClass]="agentBadge(a.status)" style="font-size:10px;margin-bottom:8px">{{a.status}}</span>
            <div *ngIf="a.status === 'On Call'" style="font-size:11px;color:var(--csr-text2);margin-bottom:4px">
              <span class="material-icons" style="font-size:11px;vertical-align:middle;color:var(--csr-accent)">phone</span> {{a.callTime}}
            </div>
            <div style="display:flex;justify-content:space-between;font-size:10px;color:var(--csr-text2)">
              <span>Handled: <strong style="color:var(--csr-text)">{{a.handled}}</strong></span>
              <span>Avg: <strong style="color:var(--csr-text)">{{a.avg}}</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Charts hidden — Hourly Complaint Volume and Complaints by Service Unit not linked to contact centre -->

</div>
